import { AreaCode } from '@ebalance/proto/bfftypes/v1/area_pb'

import {
  INVALID,
  bool,
  defineFilterCodec,
  field,
  listOf,
  oneOf,
  protoEnumValues,
  text,
} from '~/models/filterCodec'
import { workflowSectionFilter } from '~/models/workflowSectionFilter'
import {
  DEFAULT_FILTER_STATE,
  type FilterBarState,
} from '~/pages/WorkflowCases/components/FilterBar'
import { CASE_SECTION_TABS } from '~/pages/WorkflowCases/models/filterOptions'
import type { WorkflowCaseStatusSegment } from '~/pages/WorkflowCases/models/workflowCaseFilter'

/**
 * 業務ワークフロー一覧のフィルタバー保持 key。
 *
 * AC-SC-031 [P0] (`docs/specs/common/shared-components.md`) が保存媒体まで
 * localStorage と規定する (タブ生存期間で消える sessionStorage は「再訪時に復元」を
 * 満たさない)。
 */
export const WORKFLOW_CASES_FILTERS_STORAGE_KEY =
  'ebalance-workflow-cases-filters'

const SEGMENTS: readonly WorkflowCaseStatusSegment[] = [
  'all',
  'notStarted',
  'inProgress',
]

/** `YYYY-MM-DD` か空文字 (= 未指定) だけを通す。 */
const dateInput = field<string>((wire) =>
  typeof wire === 'string' && (wire === '' || /^\d{4}-\d{2}-\d{2}$/.test(wire))
    ? wire
    : INVALID,
)

// 画面のタブ (CASE_SECTION_TABS) にある値だけ復元する。 旧保存値の当日・翌日・翌々日は単日に寄せる
const sectionFilter = workflowSectionFilter(CASE_SECTION_TABS)

/**
 * 未保存・壊れた JSON・不正値はすべて既定値へ落とす。 配列は要素単位で検査し、
 * 知らない値だけを捨てる (配列ごと捨てると、 1 つ古いエリアが混ざっただけで選択が
 * 全部消える)。
 */
export const workflowCasesFiltersCodec = defineFilterCodec<FilterBarState>({
  defaults: () => DEFAULT_FILTER_STATE,
  fields: {
    section: sectionFilter,
    statusSegment: oneOf(SEGMENTS),
    showComplete: bool(),
    showDeleted: bool(),
    onlyViewerActionRequired: bool(),
    areaCodes: listOf(oneOf(protoEnumValues(AreaCode))),
    bgCodes: listOf(text()),
    tagLabels: listOf(text()),
    targetDateFrom: dateInput,
    targetDateTo: dateInput,
  },
})
